import React, { useState } from 'react';
import { SketchPicker } from 'react-color';

import { ThemeTypes } from './utils/enums';

import {
	ChatbotThemeColors,
	ChatbotThemeGradients,
} from '@/components/utils/constants';

interface ColorPickerProps {
	themeType: string;
	selectedColor: string;
	setSelectedColor: (color: string) => void;
	setThemeType: (theme: ThemeTypes) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
	themeType,
	selectedColor,
	setSelectedColor,
	setThemeType,
}) => {
	const [showColorPicker, setShowColorPicker] = useState(false);

	const isSelected = (value: string) =>
		selectedColor === value ? 'border-purpleBrand-500' : '';

	return (
		<div className="mb-8">
			<h3 className="font-medium mb-2">Color Theme</h3>
			<p className="text-sm text-gray-500 mb-3">
				Change the colors to customize your bot
			</p>

			{/* Solid colors row */}
			<div className="flex items-center gap-3 mb-3">
				{ChatbotThemeColors.map((color) => (
					<div
						key={color.name}
						className={`w-6 h-6 rounded-full cursor-pointer border-2 ${isSelected(
							color.name,
						)}`}
						style={{ backgroundColor: color.value }}
						onClick={() => {
							setSelectedColor(color.name);
							setShowColorPicker(false);
							setThemeType(ThemeTypes.Color);
						}}
					></div>
				))}

				{themeType === ThemeTypes.Custom && (
					<div
						className={`w-6 h-6 rounded-full cursor-pointer border-2 ${isSelected(
							selectedColor,
						)}`}
						style={{ backgroundColor: selectedColor }}
					></div>
				)}

				<div
					className="w-6 h-6 rounded-full border border-gray-400 flex items-center justify-center cursor-pointer text-gray-500"
					onClick={() => setShowColorPicker(!showColorPicker)}
				>
					+
				</div>
			</div>

			{/* Gradient row */}
			<div className="flex items-center gap-3">
				{ChatbotThemeGradients.map((gradient) => (
					<div
						key={gradient.name}
						className={`w-6 h-6 rounded-full cursor-pointer border-2 ${isSelected(
							gradient.name,
						)}`}
						style={{ background: gradient.value }}
						onClick={() => {
							setSelectedColor(gradient.name);
							setShowColorPicker(false);
							setThemeType(ThemeTypes.Gradient);
						}}
					></div>
				))}
			</div>

			{showColorPicker && (
				<div className="mt-4">
					<SketchPicker
						color={selectedColor}
						onChangeComplete={(color) => {
							setThemeType(ThemeTypes.Custom);
							setSelectedColor(color.hex);
						}}
					/>
				</div>
			)}
		</div>
	);
};

export default ColorPicker;
